import { render, staticRenderFns } from "./LKI02.vue?vue&type=template&id=005c3b58&scoped=true"
import script from "./LKI02.vue?vue&type=script&lang=js"
export * from "./LKI02.vue?vue&type=script&lang=js"
import style0 from "./LKI02.vue?vue&type=style&index=0&id=005c3b58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c3b58",
  null
  
)

export default component.exports